import { render } from "./default-setting.vue?vue&type=template&id=138e2b91&ts=true"
import script from "./default-setting.vue?vue&type=script&lang=ts"
export * from "./default-setting.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__